module.exports = __webpack_public_path__ + "static/media/xibushuju.bfd654e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/xibushuju.mp4
// module id = JKQv
// module chunks = 0